import React, { useEffect, useState } from 'react';
import MenuSportItem from './MenuSportItem';
import InEvidenzaSection from './in-evidenza/InEvidenzaSection';
import PrematchContext from '../../../contexts/PrematchContext';
import { classIf, getConfiguration, getFavoriteTournamentsData, getFilterDesc, getFilterDescWithLive, getTorneiInEvidenza, iconSportCssClass } from '../../../data/utils';
import MatchSearch from '../MatchSearch';
import { appConfig, getLabel } from '../../../InitData';
import GoUpBtn from '../../GoUpBtn';
import FavoriteTournaments from './favorite-tournaments/FavoriteTournaments';
import { PageDataContext } from '../../../PageData';
import BetslipBanners from '../../BetslipBanners';
import { TEMPORAL_FILTERS } from '../../../data/constants';
import { useLayout } from '../../../UISettingsProvider';
import { useFavoriteTournaments } from '../../../prematch/favorite-tournaments/FavoriteTournamentsProvider';
import SearchBar from '../../../prematch/event-search/SearchBar';
import AllEventsButtons from './AllEventsButtons';
import DaysButtons from './DaysButtons';

function applyFilter(data, currentFilter) {
    const sports = [];
    data.sport.forEach(sport => {
        if (sport.filters[currentFilter] == null) {
            return;
        }
        const categories = [];
        sport.categories.forEach(category => {
            if (category.filters[currentFilter] == null) {
                return;
            }
            const tournaments = [];
            category.tournaments.forEach(tournament => {
                if (tournament.filters[currentFilter] == null) {
                    return;
                }
                tournaments.push(tournament);
            });
            if (tournaments.length > 0) {
                categories.push({
                    ...category,
                    tournaments
                });
            }
        });
        if (categories.length > 0) {
            sports.push({
                ...sport,
                categories
            });
        }
    });
    return sports;
}

function MenuPrematchAlt(props) {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const favoriteTournaments = useFavoriteTournaments();
    const layout = useLayout();
    const pageDataContext = React.useContext(PageDataContext);

    function handleOpenFavoriteTournaments() {
        const tournamentsIds = Array.from(Object.keys(favoriteTournaments));
        prematchContext.openTournaments(tournamentsIds);
    }

    function handleInEvidenzaButton() {
        prematchContext.openTournaments(inEvidenza.tournamentsIds);
    }

    function handleSportsSelectionButton() {
        if (window.appConfig.SHOP_MODE) {
            prematchContext.openSportOverview();
        } else {
            prematchContext.openSelectionMenu(null, null);
        }
    }

    function handleExtraEventsButton() {
        prematchContext.openExtraEvents();
    }

    const [collapsed, setCollapsed] = useState(false);
    function handleCollapseButton() {
        if (!collapsed) {
            document.body.classList.add('e-largo');
        } else {
            document.body.classList.remove('e-largo');
        }
        setCollapsed(!collapsed);
    }

    const menuOnRight = layout.order.sidebarSx.localeCompare('ord-3') === 0;
    const currentFilter = prematchContext.temporalFilter;
    const favoriteTournamentsData = getFavoriteTournamentsData(props.data.sport, favoriteTournaments, currentFilter);
    let inEvidenza = getTorneiInEvidenza(props.data.sport, currentFilter);
    const data = props.data;
    const sports = applyFilter(data, currentFilter);
    const sportButtons = [];
    const sportIcons = [];
    sports.forEach(sport => {
        sportButtons.push(
            <MenuSportItem key={sport.id} {...sport} menuLiveTogglers={props.menuLiveTogglers} />
        );
        const icoSport = iconSportCssClass(sport.id, sport.iconClass);
        sportIcons.push(
            <div key={sport.id} className="bloccheti-icone-ristrette">
                <div className={`icona-sport img-fluid ico-sport ${icoSport}`}></div>
            </div>
        );
    });

    const showFavoriteTournaments = favoriteTournamentsData.sportsList.length > 0;
    const showIncreasedOddsButton = props.data.showIncreasedOddsButton;

    return (
        <div className={"sidebar-sx-sport col stringimento-sidebar go-up-arrow-on-overflow " + layout.order.sidebarSx + classIf(collapsed, 'stringi')} id="sidebar-sx">
            <GoUpBtn />
            {pageDataContext != null && pageDataContext.menu.banners.length > 0 &&
                <BetslipBanners banners={pageDataContext.menu.banners} />
            }
            <div className="widget-filtro-side bordato-widget bordo-tondo margine-giu">
                <div className="filtro-side-n">
                    {/* Se il menu e' sulla destra mostro la freccia come primo elemento e ruoto l'immagine */}
                    {menuOnRight &&
                        <div className="pointer f-sidebarSX tasto-stringi ruota-180" onClick={handleCollapseButton}><i className="fas fa-chevron-left"></i></div>
                    }
                    <a className="elemento-filtro-side-n pointer f-attivo" href="#/prematch">Prematch</a>
                    <a className="elemento-filtro-side-n pointer" href="#/live">Live</a>
                    {!menuOnRight &&
                        <div className="pointer f-sidebarSX tasto-stringi" onClick={handleCollapseButton}><i className="fas fa-chevron-left"></i></div>
                    }
                </div>
                <a className="widget__button--live widget__button--noTournements" href={conf.iwh? appConfig?.ROUTES?.live?.['multi-bet'] : "#/live"}>{getLabel('menu.live')}</a>
                <AllEventsButtons />
                {conf.foc?.enb &&
                    <div className="widgetFiltroSide__quoteFavorite" >

                        <a href-disabled="#!" role="button" tabIndex="0" className={`pointer ${prematchContext.section === 'favorite-odds' && 'active'}`} onClick={() => prematchContext.openFavoriteOdds()}>{getLabel('favorite_odds')}</a>
                    </div>
                }
                <div className="elementi-widget-fasce">
                    <div className="widget-ricerca-side">
                        {(() => {
                            switch (conf.srt) {
                                case 'DEFAULT':
                                    return <SearchBar />;
                                case 'FULLSCREEN':
                                    return <MatchSearch isLive={props.isLive} data={props.data} />;
                                default:
                                    return <MatchSearch isLive={props.isLive} data={props.data} />;
                            }
                        })()}
                    </div>
                    <div className='temporal__filters'>
                        {TEMPORAL_FILTERS.map((filter, i) => {
                            function handleClick() {
                                prematchContext.setTemporalFilter(filter);
                            }
                            return (
                                <span key={i} className={"fascia pointer " + classIf(currentFilter === filter, 'f-attiva ') + `date${filter}`} onClick={handleClick}>{conf.iwh ? getFilterDescWithLive(filter) : getFilterDesc(filter)}</span>
                            );
                        })}
                    </div>
                    <DaysButtons />
                </div>
            </div>
            <div className="widget-competizioni-side">
                {showFavoriteTournaments &&
                    <FavoriteTournaments data={favoriteTournamentsData} />
                }
                {inEvidenza.sportsList.length > 0 &&
                    <InEvidenzaSection data={inEvidenza} />
                }
                <div className="apri-partite-in-evidenza maiuscolo">
                    {showFavoriteTournaments &&
                        <a href-disabled="#!" role="button" tabIndex="0" className="pointer bg-colore-1 bianco margine-giu" onClick={handleOpenFavoriteTournaments}>{getLabel('menu_prematch.open_favorite_tournaments')}</a>
                    }
                    {inEvidenza.sportsList.length > 0 &&
                        <a href-disabled="#!" role="button" tabIndex="0" className="pointer bg-colore-1 bianco margine-giu" onClick={handleInEvidenzaButton}>{getLabel('menu_prematch.apri_tornei_ev')}</a>
                    }
                    <a href-disabled="#!" role="button" tabIndex="0" className="pointer bg-colore-1 bianco margine-giu" onClick={handleSportsSelectionButton}>{getLabel('menu_prematch.selezione_sport')}</a>
                    {showIncreasedOddsButton &&
                        <a href-disabled="#!" role="button" tabIndex="0" className="pointer bg-colore-1 bianco margine-giu" onClick={handleExtraEventsButton}>{getLabel('prematch.extra_events.title')}</a>
                    }
                </div>
                <div id="accordionLaterale" className="contenitore-competizioni-sport" role="tablist" aria-multiselectable="true">
                    {sportButtons}
                </div>
            </div>
            <div className="sidebar-ristretta-sx">
                <div className={"pointer f-sidebarSX tasto-allarga" + classIf(menuOnRight, 'ruota-180')} onClick={handleCollapseButton}><i className="fas fa-chevron-right"></i></div>
                <div className="icone-ristrette">
                    {sportIcons}
                </div>
            </div>
        </div>
    );
}

export default MenuPrematchAlt;  